export const LANGUAGE_DEBUG_MODE_CODE = "cimode";
